import { FC } from "react";
import "./style.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { PATH_LIST } from "shared/lib/react-router";
import { ChangeLanguage } from "widgets/change-language";
import { useStore } from "zustand";
import { accountStore } from "entities/account";
import Chat from "../../../../../assets/verification/Contacts.svg";
import Back from "../../../../../assets/AuthBack.svg";
import Close from "../../../../../assets/verification/Close.svg";
import { Capacitor } from "@capacitor/core";

type PropsType = {
  openChat: () => void;
  close: () => void;
};

export const VerificationHeader: FC<PropsType> = ({ openChat, close }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    modalOpened,
    setModalOpened,
    parsModalOpened,
    setParsModalOpened,
    removeParsedData,
  } = useStore(accountStore);

  const goBack =
    location.pathname == PATH_LIST.details ||
    location.pathname == PATH_LIST.dateOfBirth ||
    location.pathname == PATH_LIST.chooseDocType ||
    location.pathname == PATH_LIST.selfieWithDocument ||
    location.pathname == PATH_LIST.proofOfAddress ||
    location.pathname == PATH_LIST.residenceAddress;

  const handleClose = () => {
    if (modalOpened !== null) {
      setModalOpened(null);
    } else if (parsModalOpened) {
      removeParsedData();
      setParsModalOpened(false);
    } else {
      close();
    }
  };

  return (
    <nav
      className="verification-navbar"
      style={{
        paddingTop: Capacitor.isNativePlatform() ? "16px" : "36px",
      }}
    >
      {goBack ? (
        <button
          onClick={() => {
            navigate(-1);
            if (parsModalOpened) {
              removeParsedData();
              setParsModalOpened(false);
            }
          }}
          style={{
            justifyContent: "flex-start",
          }}
        >
          <img src={Back} alt="back" />
        </button>
      ) : (
        <div></div>
      )}

      <div className="navbar-right">
        <ChangeLanguage
          dark={location.pathname !== PATH_LIST.welcome ? true : false}
        />
        <button
          onClick={openChat}
          style={{
            justifyContent: "flex-end",
          }}
        >
          <img className="open-chat" src={Chat} alt="chat" />
        </button>
        <button
          onClick={handleClose}
          style={{
            justifyContent: "flex-end",
          }}
        >
          <img className="close" src={Close} alt="close" />
        </button>
      </div>
    </nav>
  );
};
